import { SimpleGrid, Tab, TabList, TabPanel, TabPanels, Tabs, Box, Heading } from '@chakra-ui/react';
import React from 'react';
import { AppState } from '../Context/AppProvider';
import Card from './Components/Card';
import SEO from '../Components/SEO';

export default function Men() {
  let {data}= AppState();
  return (
    <>
        <SEO
          title="Men's Tailored & Ready-to-Wear - Ajanta Cloth House, Sirsa"
          description="Premium suiting, shirting and casual men's wear. Discover curated brands and expert service at Ajanta Cloth House."
          path="/men"
          image="https://ajantasirsa.com/og-image.png"
        />
        <Box px={6} pt={6}>
          <Heading as="h1" size="lg" color="#184a49" mb={4} fontWeight="semibold">
            Men's Suits, Shirts & Casualwear - Timeless Quality
          </Heading>
          <Box maxW={{base:'95%',md:'70%'}} color="#333" mb={6}>
            <p>
              Our men's collection brings together classic tailoring and contemporary casuals. From precision-cut suiting to everyday shirting, we stock brands and fabrics chosen for workmanship and comfort. Whether you need formal attire for events or durable daily wear, our team offers personalized guidance to match fit and fabric. Browse our curated selection online, contact the store for availability or recommendations, or visit in person for attentive service.
            </p>
          </Box>
        </Box>
        <Tabs isFitted variant='enclosed' p={3} colorScheme='teal'>
          <TabList mb='1em'>
            <Tab>Ajanta Cloth House & Ajanta Collections</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <SimpleGrid 
                minChildWidth={{base:"150px",sm:"200px",md:"300px"}} 
                mt={1} ml={"1%"} rowGap={8} columnGap={""}
              >
                
                {/* Items */}
                {
                  Array.isArray(data) && data.map((element,id) => {
                    return(
                      String(element.category || '').toLowerCase()==="men"?
                      <React.Fragment key= {id}>
                        <Card
                          src={element.image}
                          title={element.title}
                          alt={element.alt}
                          desc={element.description}
                        />
                      </React.Fragment>
                      :
                      <React.Fragment key= {id}></React.Fragment>
                    )
                  })
                }
              </SimpleGrid> 
            </TabPanel>
          </TabPanels>
        </Tabs>
    </>
  )
}
